var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCcHelper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-83.000000, -48.000000) translate(0.000000, 20.000000) translate(83.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    className: "icon-stroke"
  }), /*#__PURE__*/React.createElement("g", {
    className: "icon-fill"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.209 4.667H4.817L7.457.445c.055-.09.057-.203.006-.295C7.412.058 7.315 0 7.21 0H2.542c-.134 0-.25.091-.283.221L.509 7.222c-.022.087-.002.18.053.25.055.071.14.112.23.112h1.951l-1.65 6.049c-.037.138.031.283.161.342.13.057.283.014.364-.104l5.834-8.75c.059-.09.064-.205.013-.3-.05-.094-.149-.153-.256-.154z",
    transform: "translate(3.000000, 3.000000) translate(5.000000, 2.000000)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCcHelper);
export default __webpack_public_path__ + "static/media/payment-cc-helper.233c90ff.svg";
export { ForwardRef as ReactComponent };